module.exports = "<app-poi-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() poi=$ctrl.poi switch-tab-prefix=app.poi.update> </app-poi-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/update/partial.html
// module id = 444
// module chunks = 0